// ── ticketsDatabase.js ─────────────────────────────────────────────────
// Shared ticket categories + status metadata.
// Used by TicketForm.js (player-facing submission) and AdminPanel.js (admin view).

export const TICKET_CATEGORIES = [
  {
    group: 'Bug & Technical Issues',
    options: [
      { value: 'bug_report', label: 'Bug Report' },
      { value: 'data_not_saving', label: 'Data not saving' },
      { value: 'data_loss', label: 'Data loss' },
      { value: 'loading_issue', label: 'Loading issue' },
      { value: 'login_auth', label: 'Login / Authentication problem' },
    ],
  },
  {
    group: 'Account & Access',
    options: [
      { value: 'patreon_access', label: 'Patreon access not recognized' },
      { value: 'account_not_found', label: 'Account not found' },
      { value: 'cant_create_account', label: "Can't create account" },
    ],
  },
  {
    group: 'Gameplay & Features',
    options: [
      { value: 'feature_not_working', label: 'Feature not working' },
      { value: 'wrestler_data_issue', label: 'Wrestler / roster data issue' },
      { value: 'match_result_issue', label: 'Match result issue' },
      { value: 'title_bug', label: 'Title / championship bug' },
      { value: 'season_progression_bug', label: 'Season or show progression bug' },
    ],
  },
  {
    group: 'Content & Data',
    options: [
      { value: 'missing_wrestler', label: 'Missing wrestler' },
      { value: 'wrong_wrestler_info', label: 'Wrong wrestler info' },
      { value: 'custom_roster_issue', label: 'Custom roster issue' },
    ],
  },
  {
    group: 'General',
    options: [
      { value: 'suggestion', label: 'Suggestion / Feature request' },
      { value: 'other', label: 'Other' },
    ],
  },
];

// Flat lookup map: value -> label (used by AdminPanel to render badges)
export const TICKET_CATEGORY_LABELS = TICKET_CATEGORIES.reduce((acc, g) => {
  g.options.forEach(o => { acc[o.value] = o.label; });
  return acc;
}, {});

export const TICKET_STATUSES = [
  { value: 'open', label: 'Open', color: '#e74c3c' },
  { value: 'in_progress', label: 'In Progress', color: '#d4af37' },
  { value: 'resolved', label: 'Resolved', color: '#2ecc71' },
  { value: 'wont_fix', label: "Won't Fix", color: 'rgba(255,255,255,0.4)' },
];

export const TICKET_STATUS_MAP = TICKET_STATUSES.reduce((acc, s) => {
  acc[s.value] = s;
  return acc;
}, {});

// Lightweight browser/device fingerprint — no external lib, good enough for triage.
export function detectBrowserDevice() {
  if (typeof navigator === 'undefined') return 'Unknown';
  const ua = navigator.userAgent || '';
  let browser = 'Unknown browser';
  if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome/') && !ua.includes('Chromium')) browser = 'Chrome';
  else if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Safari/') && !ua.includes('Chrome')) browser = 'Safari';

  let os = 'Unknown OS';
  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS')) os = 'macOS';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';

  return browser + ' on ' + os;
}
